import { Card, CardContent, CardHeader, CardTitle } from "@devhop/ui";
import type { CfDashboardWebhook } from "../api/types";

// system enum -> label ลาว
const JOB_STATUS_LABELS: Record<string, string> = {
  queued: "ລໍຖ້າ",
  processing: "ກຳລັງປະມວນຜົນ",
  completed: "ສຳເລັດ",
  failed: "ລົ້ມເຫຼວ",
  dead: "ຍົກເລີກ",
};

type WebhookHealthCardProps = {
  data?: CfDashboardWebhook;
  isLoading: boolean;
};

export function WebhookHealthCard({ data, isLoading }: WebhookHealthCardProps) {
  return (
    <Card className="h-full">
      <CardHeader className="pb-2">
        <CardTitle className="text-base">
          ສະຖານະການຮັບຂໍ້ມູນ (Webhook)
        </CardTitle>
      </CardHeader>
      <CardContent>
        {isLoading && !data ? (
          <div className="h-[140px] w-full animate-pulse rounded bg-muted" />
        ) : !data ? (
          <div className="py-8 text-center text-muted-foreground text-sm">
            ຍັງບໍ່ມີຂໍ້ມູນ
          </div>
        ) : (
          <div className="space-y-3">
            <div className="flex items-baseline justify-between">
              <span className="text-muted-foreground text-sm">
                ກິດຈະກຳ (ຊ່ວງທີ່ເລືອກ)
              </span>
              <span className="font-bold text-lg tabular-nums">
                {data.totalEvents}
              </span>
            </div>
            <div>
              <div className="mb-1 text-muted-foreground text-xs">
                ສະຖານະການປະມວນຜົນ
              </div>
              {data.byJobStatus.length === 0 ? (
                <div className="text-muted-foreground text-sm">ບໍ່ມີວຽກ</div>
              ) : (
                <div className="flex flex-wrap gap-2">
                  {data.byJobStatus.map((s) => (
                    <span
                      key={s.status}
                      className="inline-flex items-center gap-1 rounded-full bg-muted px-2.5 py-1 text-xs"
                    >
                      {JOB_STATUS_LABELS[s.status] ?? s.status}
                      <span className="font-semibold tabular-nums">
                        {s.count}
                      </span>
                    </span>
                  ))}
                </div>
              )}
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
